import React from 'react';
import LayersIcon from '../atoms/LayersIcon';
import Button from '../atoms/Button';
import ChevronRightIcon from '../atoms/ChevronRightIcon';
import { Heading2, BodyText } from '../atoms/Typography';

/**
 * Settings card header — icon, title, description, Next button.
 */
export default function SettingsCardHeader({
  title,
  description,
  nextLabel = 'Next',
  onNext,
  showNext = true,
  nextDisabled = false,
  nextVariant = 'primary',
  className = '',
}) {
  return (
    <div className={`ca-settings-card__header ${className}`.trim()}>
      <div className="ca-settings-card__heading">
        <LayersIcon />
        <div>
          <Heading2>{title}</Heading2>
          {description ? <BodyText className="ca-settings-card__desc">{description}</BodyText> : null}
        </div>
      </div>
      {showNext ? (
        <Button
          variant={nextVariant}
          disabled={nextDisabled}
          onClick={onNext}
          endIcon={<ChevronRightIcon size={14} color="currentColor" />}
        >
          {nextLabel}
        </Button>
      ) : null}
    </div>
  );
}
